/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2025 Valeriy Chupurnov. All rights reserved. https://xdsoft.net
 */

export default {
	'Type something': 'Bir şeyler yaz',
	Advanced: 'Gelişmiş',
	'About Jodit': 'Jodit Hakkında',
	'Jodit Editor': 'Jodit Editor',
	"Jodit User's Guide": 'Jodit Kullanım Kılavuzu',
	'contains detailed help for using': 'kullanım için detaylı bilgiler içerir',
	'For information about the license, please go to our website:':
		'Lisans hakkında bilgi için lütfen web sitemize gidin:',
	'Buy full version': 'Tam versiyonunu satın al',
	'Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.':
		'Copyright © XDSoft.net - Chupurnov Valeriy. Tüm hakları saklıdır.',
	Anchor: 'Bağlantı',
	'Open in new tab': 'Yeni sekmede aç',
	'Open in fullsize': 'Editörü tam ekranda aç',
	'Clear Formatting': 'Stili temizle',
	'Fill color or set the text color': 'Renk doldur veya yazı rengi seç',
	Redo: 'Yinele',
	Undo: 'Geri Al',
	Bold: 'Kalın',
	Italic: 'İtalik',
	'Insert Unordered List': 'Sırasız Liste Ekle',
	'Insert Ordered List': 'Sıralı Liste Ekle',
	'Align Center': 'Ortala',
	'Align Justify': 'Kenarlara Yasla',
	'Align Left': 'Sola Yasla',
	'Align Right': 'Sağa Yasla',
	'Insert Horizontal Line': 'Yatay Çizgi Ekle',
	'Insert Image': 'Resim Ekle',
	'Insert file': 'Dosya Ekle',
	'Insert youtube/vimeo video': 'Youtube/Vimeo Videosu Ekle',
	'Insert link': 'Bağlantı Ekle',
	'Font size': 'Font Boyutu',
	'Font family': 'Font Ailesi',
	'Insert format block': 'Blok Ekle',
	Normal: 'Normal',
	'Heading 1': 'Başlık 1',
	'Heading 2': 'Başlık 2',
	'Heading 3': 'Başlık 3',
	'Heading 4': 'Başlık 4',
	Quote: 'Alıntı',
	Code: 'Kod',
	Insert: 'Ekle',
	'Insert table': 'Tablo Ekle',
	'Decrease Indent': 'Girintiyi Azalt',
	'Increase Indent': 'Girintiyi Arttır',
	'Select Special Character': 'Özel Karakter Seç',
	'Insert Special Character': 'Özel Karakter Ekle',
	'Paint format': 'Resim Biçimi',
	'Change mode': 'Mod Değiştir',
	Margins: 'Boşluklar',
	top: 'Üst',
	right: 'Sağ',
	bottom: 'Alt',
	left: 'Sol',
	Styles: 'CSS Stilleri',
	Classes: 'CSS Sınıfları',
	Align: 'Hizalama',
	Right: 'Sağ',
	Center: 'Ortalı',
	Left: 'Sol',
	'--Not Set--': 'Belirsiz',
	Src: 'Kaynak',
	Title: 'Başlık',
	Alternative: 'Alternatif Yazı',
	Link: 'Link',
	'Open link in new tab': 'Bağlantıyı yeni sekmede aç',
	Image: 'Resim',
	file: 'Dosya',
	'Image properties': 'Resim özellikleri',
	Cancel: 'İptal',
	Ok: 'Tamam',
	'Your code is similar to HTML. Keep as HTML?':
		'Kodunuz HTML koduna benziyor. HTML olarak devam etmek ister misiniz?',
	'Paste as HTML': 'HTML olarak yapıştır',
	Keep: 'Sakla',
	Clean: 'Temizle',
	'Insert as Text': 'Yazı olarak ekle',
	'Word Paste Detected': 'Word biçiminde yapıştırma algılandı',
	'The pasted content is coming from a Microsoft Word/Excel document. Do you want to keep the format or clean it up?':
		'Der Inhalt, den Sie einfügen, stammt aus einem Microsoft Word / Excel-Dokument. Möchten Sie das Format erhalten oder löschen?',
	'Insert only Text': 'Sadece yazıyı ekle',
	'File Browser': 'Dosya Listeleyici',
	'Error on load list': 'Liste yüklenirken hata oluştu',
	'Error on load folders': 'Klasörler yüklenirken hata oluştur',
	'Are you sure?': 'Emin misiniz?',
	'Enter Directory name': 'Dizin yolu giriniz',
	'Create directory': 'Dizin oluştur',
	'type name': 'İsim yaz',
	'Drop image': 'Resim bırak',
	'Drop file': 'Dosya bırak',
	'or click': 'veya tıkla',
	'Alternative text': 'Alternatif yazı',
	Browse: 'Gözat',
	Upload: 'Yükle',
	Background: 'Arka plan',
	Text: 'Yazı',
	Top: 'Üst',
	Middle: 'Orta',
	Bottom: 'Aşağı',
	'Insert column before': 'Öncesine kolon ekle',
	'Insert column after': 'Sonrasına kolon ekle',
	'Insert row above': 'Üstüne satır ekle',
	'Insert row below': 'Altına satır ekle',
	'Delete table': 'Tabloyu sil',
	'Delete row': 'Satırı sil',
	'Delete column': 'Kolonu sil',
	'Empty cell': 'Hücreyi temizle',
	Delete: 'Sil',
	'Strike through': 'Üstü çizili',
	Underline: 'Alt çizgi',
	Break: 'Satır sonu',
	'Search for': 'Ara',
	'Replace with': 'Şununla değiştir',
	Replace: 'Değiştir',
	Edit: 'Düzenle',
	'Vertical align': 'Dikey hizala',
	'Horizontal align': 'Yatay hizala',
	Filter: 'Filtre',
	'Sort by changed': 'Değişime göre sırala',
	'Sort by name': 'İsme göre sırala',
	'Sort by size': 'Boyuta göre sırala',
	'Add folder': 'Klasör ekle',
	Split: 'Ayır',
	'Split vertical': 'Dikey ayır',
	'Split horizontal': 'Yatay ayır',
	Merge: 'Birleştir',
	'Add column': 'Kolon ekle',
	'Add row': 'Satır ekle',
	Border: 'Kenarlık',
	'Embed code': 'Kod ekle',
	Update: 'Güncelle',
	superscript: 'Üst yazı',
	subscript: 'Alt yazı',
	'Cut selection': 'Seçilimi kes',
	Paste: 'Yapıştır',
	'Choose Content to Paste': 'Yapıştırılacak içerik seç',
	'Chars: %d': 'Harfler: %d',
	'Words: %d': 'Kelimeler: %d',
	All: 'Tümü',
	'Select %s': 'Seç: %s',
	'Select all': 'Tümünü seç',
	source: 'Kaynak',
	bold: 'Kalın',
	italic: 'italik',
	brush: 'Fırça',
	link: 'Bağlantı',
	undo: 'Geri al',
	redo: 'Yinele',
	table: 'Tablo',
	image: 'Resim',
	eraser: 'Silgi',
	paragraph: 'Paragraf',
	fontsize: 'Font boyutu',
	video: 'Video',
	font: 'Font',
	about: 'Hakkında',
	print: 'Yazdır',
	underline: 'Alt çizgi',
	strikethrough: 'Üstü çizili',
	indent: 'Girinti',
	outdent: 'Çıkıntı',
	fullsize: 'Tam ekran',
	shrink: 'Küçült',
	hr: 'Ayraç',
	ul: 'Sırasız liste',
	ol: 'Sıralı liste',
	cut: 'Kes',
	selectall: 'Tümünü seç',
	'Open link': 'Bağlantıyı aç',
	'Edit link': 'Bağlantıyı düzenle',
	'No follow': 'Nofollow özelliği',
	Unlink: 'Bağlantıyı kaldır',
	Eye: 'Yorumu',
	pencil: 'Düzenlemek için',
	' URL': 'URL',
	Reset: 'Sıfırla',
	Save: 'Kaydet',
	'Save as ...': 'Farklı kaydet',
	Resize: 'Boyutlandır',
	Crop: 'Kırp',
	Width: 'Genişlik',
	Height: 'Yükseklik',
	'Keep Aspect Ratio': 'En boy oranını koru',
	Yes: 'Evet',
	No: 'Hayır',
	Remove: 'Sil',
	Select: 'Seç',
	'You can only edit your own images. Download this image on the host?':
		'Sadece kendi resimlerinizi düzenleyebilirsiniz. Bu görseli kendi hostunuza indirmek ister misiniz?',
	'The image has been successfully uploaded to the host!':
		'Görsel başarıyla hostunuza yüklendi',
	palette: 'Palet',
	'There are no files': 'Bu dizinde dosya yok',
	Rename: 'Yeniden isimlendir',
	'Enter new name': 'Yeni isim girin',
	preview: 'Ön izleme',
	download: 'İndir',
	'Paste from clipboard': 'Panodan yapıştır ',
	"Your browser doesn't support direct access to the clipboard.":
		'Tarayıcınız panoya doğrudan erişimi desteklemiyor.',
	'Copy selection': 'Seçimi kopyala',
	copy: 'Kopyala',
	'Border radius': 'Sınır yarıçapı',
	'Show all': 'Tümünü Göster',
	Apply: 'Uygula',
	'Please fill out this field': 'Lütfen bu alanı doldurun',
	'Please enter a web address': 'Lütfen bir web adresi girin',
	Default: 'Varsayılan',
	Circle: 'Daire',
	Dot: 'Nokta',
	Quadrate: 'Kare',
	Find: 'Bul',
	'Find Previous': 'Öncekini Bul',
	'Find Next': 'Sonrakini Bul',
	'Insert className': 'Sınıf adı girin',
	'Press Alt for custom resizing':
		'Özel yeniden boyutlandırma için Alt tuşuna basın'
};
